<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <v-snackbar v-model="showSnackBar" color="#FF1313" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-dialog v-model="addDealDialog" max-width="600px">
      <v-card>
        <v-card-title>Deal</v-card-title>
        <v-col cols="12">
          <v-select
            placeholder="Select Deal"
            color="#FF1313"
            v-model="deal.dealType"
            :items="deals"
            item-color="#FF1313"
            outlined
            dense
            clearable
            hint="You need min 3 products in deal to appear in listing"
            persistent-hint
          >
            <template v-slot:item="{ item }">
              <span class="text-left">{{ item }}</span>
            </template>
          </v-select>
        </v-col>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="addDealDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            :disabled="!deal.dealType ? true : false"
            @click="addDeal"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialogue" width="400">
      <v-card>
        <v-layout pa-4 wrap justify-center>
          <v-flex xs12>
            <span
              style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 14px;
              "
              >Do you want to delete this Offer ?</span
            >
          </v-flex>
          <v-flex xs12>
            <span
              style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 13px;
              "
              >{{ storage.name }}</span
            >
          </v-flex>
          <v-flex xs6 px-2>
            <v-btn
              tile
              block
              depressed
              dark
              color="#ff1313"
              @click="deleteProduct"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                Yes
              </span>
            </v-btn>
          </v-flex>
          <v-flex xs6 px-2>
            <v-btn
              tile
              block
              depressed
              dark
              color="#1BD93B"
              @click="deleteDialogue = false"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                No
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-layout wrap py-2>
      <v-flex xs12 sm5 md5 lg5>
        <v-layout wrap justify-start>
          <v-flex xs12 sm3 md3 lg2 xl2 pr-md-0>
            <v-img
              v-if="storage.photo != null"
              class="align-end white--text"
              :src="mediaURL + storage.photo"
              aspect-ratio="1"
              contain
              height="100px"
            >
              <v-layout style="background-color: red">
                <v-flex>
                  <span
                    style="
                      font-family: opensanssemibold;
                      font-size: 12px;
                      text-transform: uppercase;
                    "
                  >
                    {{ storage.offerStatus }}</span
                  >
                </v-flex>
              </v-layout>
            </v-img>
            <v-img
              v-else
              class="align-end white--text"
              src="../../../assets/blankImage.jpg"
              aspect-ratio="1"
              contain
              height="100px"
            >
              <v-layout style="background-color: red">
                <v-flex>
                  <span
                    style="
                      font-family: opensanssemibold;
                      font-size: 12px;
                      text-transform: uppercase;
                    "
                  >
                    {{ storage.offerStatus }}</span
                  >
                </v-flex>
              </v-layout></v-img
            >
          </v-flex>
          <v-flex align-self-center xs12 sm9 md9 lg9 xl9>
            <v-layout wrap pt-3 pl-sm-3>
              <v-flex xs9 text-left>
                <span
                  style="
                    font-family: opensanslight;
                    font-size: 14px;
                    color: #8d8d8d;
                  "
                  >Name :</span
                >
                <span
                  style="
                    font-family: opensanssemibold;
                    font-size: 13px;
                    color: #000000;
                  "
                >
                  {{ storage.name }}</span
                >
              </v-flex>
              <v-flex xs3 text-right>
                <v-switch
                  :disabled="
                    storage.offerStatus == 'pending' ||
                    storage.offerStatus == 'rejected'
                      ? true
                      : false
                  "
                  v-model="storage.status"
                  true-value="active"
                  false-value="inactive"
                  color="#5DC57C"
                  hide-details
                  :ripple="false"
                  class="statusKey"
                  :loading="statusLoading"
                  @click="changeOfferStatus(storage)"
                >
                  <template slot="label">
                    <span
                      class="text-capitalize"
                      style="
                        color: #000000;
                        font-family: opensanssemibold;
                        font-size: 16px;
                      "
                    >
                      {{ storage.status }}
                    </span>
                  </template>
                </v-switch>
              </v-flex>
              <v-flex xs12 text-left>
                <v-tooltip max-width="300px" :color="appColor" right>
                  <template v-slot:activator="{ on, attrs }">
                <span
                v-bind="attrs" v-on="on"
                  style="
                    font-family: opensanslight;
                    font-size: 14px;
                    color: #8d8d8d;
                  "
                  >Description :
                </span>
                <span
                v-bind="attrs" v-on="on"
                  class="text"
                  style="
                    font-family: opensanssemibold;
                    font-size: 13px;
                    color: #000000;
                  "
                >
                  {{ storage.description }}
                </span>
                    <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">
                      Button
                    </v-btn> -->
                    
                  </template>
                  <span>{{ storage.description}}</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex text-left xs1 text-center hidden-md-and-down>
            <v-divider vertical></v-divider>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex text-left xs12 sm7 lg7>
        <v-layout wrap justify-space-between fill-height>
          <v-flex sm3 md3 lg3 xl3>
            <v-layout wrap>
              <v-flex xs6 sm12>
                <span
                  style="
                    color: #8d8d8d;
                    font-family: opensanslight;
                    font-size: 14px;
                  "
                >
                  Starting Date
                </span>
              </v-flex>
              <v-flex xs6 sm12>
                <span
                  style="
                    font-family: opensanssemibold;
                    font-size: 13px;
                    color: #000000;
                  "
                  v-html="DateFormatted(storage.starting)"
                >
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex sm3 md3 lg3 xl3>
            <v-layout wrap>
              <v-flex xs6 sm12>
                <span
                  style="
                    color: #8d8d8d;
                    font-family: opensanslight;
                    font-size: 14px;
                  "
                >
                  Ending Date
                </span>
              </v-flex>
              <v-flex xs6 sm12>
                <span
                  style="
                    font-family: opensanssemibold;
                    font-size: 13px;
                    color: #000000;
                  "
                  v-html="DateFormatted(storage.ending)"
                >
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm5 lg3>
            <v-layout wrap>
              <v-flex xs6 sm12>
                <span
                  style="
                    color: #8d8d8d;
                    font-family: opensanslight;
                    font-size: 14px;
                  "
                >
                  Offer cities
                </span>
              </v-flex>
              <v-flex
                style="
                  font-family: opensanssemibold;
                  font-size: 13px;
                  color: #000000;
                "
                xs6
                sm12
                v-for="(item, i) in storage.cities"
                :key="i"
              >
                {{ item }}
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex sm1 lg2>
            <v-btn @click="openDialog(storage._id)" icon color="red">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-btn :to="'Offers/Add? id=' + storage._id" icon color="green">
              <v-icon>mdi-archive-edit-outline</v-icon>
            </v-btn>
          </v-flex>
          <!-- <v-flex sm6 md5 lg5 xl5 text-left style="background-color:red">
            <v-layout wrap justify-space-between fill-height>
              <v-flex xs12 xl4 align-self-start>
                <v-layout wrap justify-start>
                  <v-flex xs12 text-left>
                    <span
                      style="
                        color: #8d8d8d;
                        font-family: opensanslight;
                        font-size: 14px;
                      "
                    >
                      Offer Status
                    </span>
                  </v-flex>
                  <v-flex xs12 text-left>
                    <span
                      style="
                        font-family: opensansbold;
                        color: #3bc17a;
                        font-size: 14px;
                      "
                    >
                      <span  style="color: #ff1313">{{storage.offerStatus}} </span>
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>
              
              <v-flex xs12 align-self-end>
                <v-layout wrap justify-center fill-height>
                  <v-flex xs4 text-left align-self-end>
                    <v-layout wrap>
                      <v-flex text-left xs12>
                        <span
                          style="
                            color: #8d8d8d;
                            font-family: opensanslight;
                            font-size: 14px;
                          "
                        >
                          Offer
                        </span>
                      </v-flex>
                      <v-flex text-left xs12>
                        <span
                          style="
                            font-family: opensansbold;
                            color: #3bc17a;
                            font-size: 20px;
                          "
                        >
                        
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs4 text-left align-self-end>
                    <v-layout wrap justify-center>
                      <v-flex text-left xs12>
                        <span
                          style="
                            color: #8d8d8d;
                            font-family: opensanslight;
                            font-size: 14px;
                          "
                        >
                          Offer Price
                        </span>
                      </v-flex>
                      <v-flex text-lwft xs12>
                        <span
                          style="
                            font-family: opensansbold;
                            color: #3bc17a;
                            font-size: 20px;
                          "
                        >
                          jk
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs4 text-center align-self-end>
                    <v-btn
                      tile
                      block
                      small
                      outlined
                      color="warning"
                      style="text-transform: none"
                      :to="'/Seller/Offers/Add/' + storage._id"
                    >
                      <span
                        style="
                          color: #000;
                          font-family: poppinsregular;
                          font-size: 14px;
                        "
                      >
                        <v-icon left>mdi-pencil</v-icon>
                        Edit
                      </span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex> -->
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  props: ["storage"],
  data() {
    return {
      appLoading: false,
      timeout: 5000,
      msg: "",
      ID: null,
      ServerError: false,
      showSnackBar: false,
      statusLoading: false,
      deleteDialogue: false,
      addDealDialog: false,
      deals: ["Buy 2 Get 1 Free", "Buy 3 above 5000 INR at 3000 INR"],
      deal: {
        dealType: null,
      },
    };
  },
  methods: {
    DateFormatted(params) {
      // moment().format("dddd, MMMM Do YYYY, h:mm:ss a")
      // return params ? moment(params).format("DD-MMMM-Y <br> hh:mm A") : "";

      
      params= moment(params).subtract(5, 'h').subtract(30, 'm')
      return params ? moment(params).format("DD-MMMM-Y <br> hh:mm A") : "";
    },
    openDialog(item) {
      (this.ID = item), (this.deleteDialogue = true);
    },
    changeOfferStatus(item) {
      this.statusLoading = true;

      axios({
        method: "POST",
        url: "/seller/offer/status/change/" + item._id,
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          status: item.status,
        },
      })
        .then((response) => {
          this.statusLoading = false;
          if (response.data.status) {
            this.msg = "Offer Status Changed to " + item.status;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.statusLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteProduct() {
      this.appLoading = true;
      axios({
        method: "post",
        url: "seller/offer/delete/" + this.ID,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.deleteDialogue = false;
            this.$emit("stepper", {
              getData: true,
            });
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    addDeal() {
      this.appLoading = true;
      var deal = {};
      deal["productid"] = this.storage._id;
      deal["dealtype"] = this.deal.dealType;
      axios({
        method: "POST",
        url: "/home/deal/add",
        data: deal,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$router.push("/Seller/Product/Updated/" + this.storage._id);
            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      day = day < 10 ? "0" + day : day;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>

<style>
div.vertical-line {
  width: 1px; /* Line width */
  background-color: #8d8d8d; /* Line color */
  height: 100%; /* Override in-line if you want specific height. */
  float: left; /* Causes the line to float to left of content. 
        You can instead use position:absolute or display:inline-block
        if this fits better with your design */
}
.statusKey.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
</style>